import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Component from '../components/Reports/index'
import { setReport, fetchReports } from '../ducks/reports'

function mapStateToProps(state) {
  return {
    reports: state.reports.list,
    fetched: state.reports.fetched,
    fetching: state.reports.fetching,
    report: state.reports.selected,
  }
}

function mapDispatchToProps(dispatch) {
  const actions = { setReport, fetchReports, push }
  return { actions: bindActionCreators(actions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./containers/Reports.js